/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Video_Encoding_ProgressInputs */



/**
* | output |
* | --- |
* | "Encoding video: {timecode}" |
*
* @param {Audio_Description_Export_Status_Video_Encoding_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_progress = /** @type {((inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Encodage vidéo : ${i?.timecode}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Videokodierung: ${i?.timecode}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Codifica video: ${i?.timecode}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Кодирование видео: ${i?.timecode}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Codificación de vídeo: ${i?.timecode}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频编码：${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオのエンコード: ${i?.timecode}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो एन्कोडिंग: ${i?.timecode}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Codificação de vídeo: ${i?.timecode}`)
	return /** @type {LocalizedString} */ (`Encoding video: ${i?.timecode}`)
});